import confetti from 'canvas-confetti';

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('joined.html')) {
    const isMobile = window.innerWidth <= 1024;
    
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { 
        x: isMobile ? 0.7 : 0.75,
        y: isMobile ? 0.4 : 0.3
      }
    });
  }

  const addStepTransitions = () => {
    const steps = document.querySelectorAll('.step');
    steps.forEach(step => {
      step.style.transition = 'all 0.3s ease-in-out';
      
      step.addEventListener('mouseenter', () => {
        if (!step.classList.contains('active')) {
          step.style.transform = 'translateX(5px)';
        }
      });
      
      step.addEventListener('mouseleave', () => {
        step.style.transform = 'translateX(0)';
      });
    });
  }

  const addButtonAnimations = () => {
    const buttons = document.querySelectorAll('.submit-btn');
    buttons.forEach(button => {
      button.style.transition = 'all 0.2s ease-in-out';
      
      button.addEventListener('mouseenter', () => {
        button.style.transform = 'scale(1.02)';
      });
      
      button.addEventListener('mouseleave', () => {
        button.style.transform = 'scale(1)';
      });
    });
  }

  addStepTransitions();
  addButtonAnimations();

  const signupForm = document.getElementById('signupForm');
  const loginForm = document.getElementById('loginForm');
  const switchToLogin = document.getElementById('switchToLogin');
  const switchToSignup = document.getElementById('switchToSignup');
  
  if (switchToLogin) {
    switchToLogin.addEventListener('click', (e) => {
      e.preventDefault();
      signupForm.classList.add('hidden');
      loginForm.classList.remove('hidden');
    });
  }
  
  if (switchToSignup) {
    switchToSignup.addEventListener('click', (e) => {
      e.preventDefault();
      loginForm.classList.add('hidden');
      signupForm.classList.remove('hidden');
    });
  }

  const toggleButtons = document.querySelectorAll('.toggle-password');
  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
      input.setAttribute('type', type);
      
      button.innerHTML = type === 'password'
        ? '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>'
        : '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" y1="2" x2="22" y2="22"/></svg>';
    });
  });

  const text = "Explore new destinations with AI-powered tour planning.";
  const words = text.split(" ");
  const revealText = document.getElementById('revealText');

  words.forEach(word => {
    const wordContainer = document.createElement('span');
    wordContainer.className = 'reveal-word';

    const ghostWord = document.createElement('span');
    ghostWord.className = 'reveal-word-ghost';
    ghostWord.textContent = word;

    const mainWord = document.createElement('span');
    mainWord.className = 'reveal-word-main';
    mainWord.textContent = word;
    mainWord.style.opacity = '0';

    wordContainer.appendChild(ghostWord);
    wordContainer.appendChild(mainWord);
    revealText.appendChild(wordContainer);
  });

  function updateWordOpacity() {
    const container = document.querySelector('.text-reveal-container');
    const containerRect = container.getBoundingClientRect();
    const containerTop = containerRect.top;
    const windowHeight = window.innerHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop === 0) {
      const wordElements = document.querySelectorAll('.reveal-word-main');
      wordElements.forEach(word => {
        word.style.opacity = '0';
      });
      return;
    }
    
    const visibleHeight = windowHeight - containerTop;
    const scrollProgress = Math.min(Math.max((visibleHeight / windowHeight) * 1.5, 0), 1);

    const wordElements = document.querySelectorAll('.reveal-word-main');
    const totalWords = wordElements.length;

    wordElements.forEach((word, index) => {
      const start = index / totalWords;
      const end = start + (1 / totalWords);
      
      let opacity = 0;
      if (scrollProgress >= start && scrollProgress <= end) {
        opacity = (scrollProgress - start) / (end - start);
      } else if (scrollProgress > end) {
        opacity = 1;
      }
      
      word.style.opacity = opacity;
    });
  }

  window.addEventListener('scroll', updateWordOpacity);
}); 